const teamRoles = {
  captain: {
    id: 1,
    name: 'КАПИТАН'
  },
  main: {
    id: 2,
    name: 'ОСНОВА'
  },
  reserve: {
    id: 3,
    name: 'РЕЗЕРВ'
  }
};

export default teamRoles;



// WEBPACK FOOTER //
// ./src/components/teamRoles.js